import { Contract } from "@models/contract.model";
import { Budget } from "@models/budget.model";
import { Pricesheet } from "@models/pricesheet.model";
import { PricesheetItem } from "@models/pricesheetitem.model";

export interface ContractBundle {
  contract: Contract;
  budgets: readonly Budget[];
  pricesheets: readonly Pricesheet[];
  pricesheetItems: readonly PricesheetItem[];
}

export const BUDGET_TYPE_LABELS: Record<string, string> = {
  PFR: "PFR",
  SUBSCRIPTION: "Subscription",
  FLAT_FEE: "Fixed / Flat fee",
  MEDIA_SPEND: "Media Spend",
};

export const REPLENISH_FREQUENCY_LABELS: Record<string, string> = {
  DAILY: "Daily",
  WEEKLY: "Weekly",
  MONTHLY: "Monthly",
  QUARTERLY: "Quarterly",
  YEARLY: "Yearly",
};

// Shared option list for BOTH Contract Billing Method and Budget Type — the two
// fields carry the same values. Values match the backend BillingModel /
// BudgetType enums so revenue charts branch correctly: PFR → take-max,
// Subscription / Fixed-Flat fee / Media Spend → N/A.
export const BILLING_MODEL_OPTIONS: { value: string; label: string }[] = [
  { value: "PFR", label: "PFR" },
  { value: "SUBSCRIPTION", label: "Subscription" },
  { value: "FLAT_FEE", label: "Fixed / Flat fee" },
  { value: "MEDIA_SPEND", label: "Media Spend" },
];

// Display labels for every stored billing model, including ones not offered in
// the picker (e.g. legacy Non-Step / Accumulate set via admin or migration).
export const BILLING_MODEL_LABELS: Record<string, string> = {
  PFR: "PFR",
  SUBSCRIPTION: "Subscription",
  FLAT_FEE: "Fixed / Flat fee",
  MEDIA_SPEND: "Media Spend",
  STEP_PRICING: "Step Pricing",
  MULTI_STEP_NON_LINEAR: "Multi-Step Non-Linear",
  NON_STEP_ACCUMULATE: "Non-Step (Accumulate)",
};

// Billing frequency for subscription contracts (MPN-1530 §4.2). Mirrors
// finance.models.BillingFrequency; the Monitor page derives the current cycle from
// this plus the contract start date rather than storing periods.
export const BILLING_FREQUENCY_OPTIONS: { value: string; label: string }[] = [
  { value: "MONTHLY", label: "Monthly" },
  { value: "QUARTERLY", label: "Quarterly" },
  { value: "SEMI_ANNUAL", label: "Semi-annual" },
  { value: "ANNUAL", label: "Annual" },
];

export const BILLING_FREQUENCY_LABELS: Record<string, string> = Object.fromEntries(
  BILLING_FREQUENCY_OPTIONS.map((o) => [o.value, o.label]),
);

export const PRODUCT_OPTIONS: { value: string; label: string }[] = [
  { value: "REACH", label: "Reach" },
  { value: "ACQUIRE", label: "Acquire" },
  { value: "CREATE", label: "Create" },
  { value: "CONNECT", label: "Connect" },
];
